export const ApiResult = {
  NONE: 0,
  SUCCESS: 1,
  ALREADY_EXIST: 2,
  NOT_EXIST: 3,
  NO_PERMISSION: 4,
  INTERNAL_ERROR: 5,
  UNKNOWN_ERROR: 6,
}

export const LoadingStatus = {
  NONE: 0,
  PENDING: 1,
  FULFILLED: 2,
  REJECTED: 3,
}

export const MenteeMenu = {
  NONE: -1,
  HOME: 0,
  TEST: 1,
  SEARCH: 2,
  MENTOR: 3,
  INVENTORY: 4,
}

export const MentorMenu = {
  HOME: 0,
  MENTEE: 1,
  SEARCH: 2,
}

export const ScoreType = {
  NONE: 0,
  JOB_CAPABILITY_WITHIN: 1,
  JOB_CAPABILITY_BETWEEN: 2,
  JOB_CAPABILITY_LEVEL_WITHIN: 3,
  JOB_CAPABILITY_LEVEL_BETWEEN: 4,
  KNOWLEDGE_WITHIN: 5,
  KNOWLEDGE_BETWEEN: 6,
  KNOWLEDGE_LEVEL_WITHIN: 7,
  KNOWLEDGE_LEVEL_BETWEEN: 8,
  ENVIRONMENT_WITHIN: 9,
  ENVIRONMENT_BETWEEN: 10,
  CHARACTER_WITHIN: 11,
  CHARACTER_BETWEEN: 12,
  INTEREST_WITHIN: 13,
  INTEREST_BETWEEN: 14,
  VALUES_WITHIN: 15,
  VALUES_BETWEEN: 16,
  ACTIVITY_WITHIN: 17,
  ACTIVITY_BETWEEN: 18,
  ACTIVITY_LEVEL_WITHIN: 19,
  ACTIVITY_LEVEL_BETWEEN: 20,
}

export const ScoreTitle: string[] = [
  '업무수행능력 (직업내)',
  '업무수행능력 (직업간)',
  '업무수행능력수준 (직업내)',
  '업무수행능력수준 (직업간)',
  '지식중요도 (직업내)',
  '지식중요도 (직업간)',
  '지식중요도수준 (직업내)',
  '지식중요도수준 (직업간)',
  '환경중요도 (직업내)',
  '환경중요도 (직업간)',
  '성격중요도 (직업내)',
  '성격중요도 (직업간)',
  '흥미중요도 (직업내)',
  '흥미중요도 (직업간)',
  '가치관중요도 (직업내)',
  '가치관요도 (직업간)',
  '업무활동 중요도 (직업내)',
  '업무활동 중요도 (직업간)',
  '업무활동수준 중요도 (직업내)',
  '업무활동수준 중요도 (직업간)',
]

export const SimpleScoreTitle: string[] = [
  '업무능력',
  '업무능력',
  '업무능력',
  '업무능력',
  '지식',
  '지식',
  '지식',
  '지식',
  '환경',
  '환경',
  '성격',
  '성격',
  '흥미',
  '흥미',
  '가치관',
  '가치관',
  '업무활동',
  '업무활동',
  '업무활동',
  '업무활동',
]
